module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FK-5d832ff04ad5694145cf6ddc41b6087b.png";